var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35355 8.14645C9.15829 7.95118 8.84171 7.95118 8.64645 8.14645C8.45118 8.34171 8.45118 8.65829 8.64645 8.85355L9.35355 8.14645ZM12.6464 12.8536C12.8417 13.0488 13.1583 13.0488 13.3536 12.8536C13.5488 12.6583 13.5488 12.3417 13.3536 12.1464L12.6464 12.8536ZM5.66667 9.33333C3.36548 9.33333 1.5 7.46785 1.5 5.16667H0.5C0.5 8.02014 2.8132 10.3333 5.66667 10.3333V9.33333ZM1.5 5.16667C1.5 2.86548 3.36548 1 5.66667 1V0C2.8132 0 0.5 2.3132 0.5 5.16667H1.5ZM5.66667 1C7.96785 1 9.83333 2.86548 9.83333 5.16667H10.8333C10.8333 2.3132 8.52014 0 5.66667 0V1ZM9.83333 5.16667C9.83333 7.46785 7.96785 9.33333 5.66667 9.33333V10.3333C8.52014 10.3333 10.8333 8.02014 10.8333 5.16667H9.83333ZM8.64645 8.85355L12.6464 12.8536L13.3536 12.1464L9.35355 8.14645L8.64645 8.85355Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.0bed2ed9b5db1d907a32f6016ad31ef6.svg";
export { ForwardRef as ReactComponent };